export enum colors {
  YELLOW = '#ffc260',
  BLUE = '#536DFE',
  LIGHT_BLUE = '#F8F9FF',
  DARK_BLUE = '#7C90FF',
  PINK = '#ff4081',
  GREEN = '#3CD4A0',
  RED = '#F44336',
  VIOLET = '#9013FE',
  GREY = '#E0E0E0',
}
